<template>
  <v-card>
    <v-card-text class="black--text">
      <div class="d-flex flex-no-wrap justify-space-between">
        <b>Контекстные данные</b>

        <v-col cols="auto" style="margin: -12px 0;">
          <BTooltipButton
            v-for="item in buttonList"
            :key="item.action"
            :tooltip="item.tooltip"
            :icon="item.icon"
            depressed
            top
            x-small
            @click="handleButtonClick(item.action)"
          />
        </v-col>
        <input
          v-show="false"
          ref="input"
          accept=".xlsx"
          type="file"
          @input="onFileChoose($event.target.files)"
        >
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import BTooltipButton from '@/components/common/BTooltipButton.vue'
import { LkPassportApi } from '@/api/resources'
import { downloadLinkByPost } from '@/helpers/downloadBlob'
import { createPassportReportModal } from '../utils'

export const TPL_UPLOAD = {
  action: 'download-passport-by-id',
  tooltip: 'Скачать данные',
  icon: 'mdi-file-download-outline',

}

export const TPL_DOWNLOAD = {
  action: 'download-prefill',
  tooltip: 'Получить шаблон предзаполнения паспорта для ОО',
  icon: 'mdi-file-download',
}

export const TPL_DOWNLOAD_EMPTY = {
  action: 'upload-prefill',
  tooltip: 'Загрузить предзаполнение',
  icon: 'mdi-file-upload',
}

export default {
  name: 'ContextualData',
  components: {
    BTooltipButton,
  },
  props: {
    passportId: Number,
    ateType: String,
  },
  computed: {
    buttonList() {
      return [
        TPL_UPLOAD,
        TPL_DOWNLOAD,
        TPL_DOWNLOAD_EMPTY,
      ]
    },
  },
  methods: {
    handleButtonClick(action) {
      switch (action) {
        case 'download-passport-by-id':
          this.onOpenModal()
          break
        case 'download-prefill':
          this.downloadPrefill()
          break
        case 'upload-prefill':
          this.uploadPrefill()
          break
        default:
      }
    },
    async onOpenModal() {
      const propsData = {
        params: { isList: false, passportId: this.passportId },
        title: 'Отчет',
      }
      const modal = await createPassportReportModal(this, propsData)
      await modal.open()
    },
    async downloadPrefill() {
      try {
        const api = new LkPassportApi()
        const url = api.downloadPrefill()
        const data = new FormData()
        data.append('ate_type', this.ateType)
        await downloadLinkByPost(
          url,
          data,
          'Шаблон предзаполнения.xlsx',
        )
      } catch (e) {
        this.$notice.errors(e)
      }
    },
    uploadPrefill() {
      this.$refs.input.click()
    },
    async onFileChoose(files) {
      const api = new LkPassportApi()
      const [file] = files
      try {
        await api.uploadPrefill(file, this.ateType)
        this.$notice.create({ type: 'success', text: 'Предзаполнение загружено' })
      } catch (e) {
        this.$notice.errors(e)
      } finally {
        this.$refs.input.value = null
      }
    },
  },
}
</script>
